<div class="btn-float">
	<i class="bi bi-file-earmark-plus-fill"></i>
</div>
<div class="dashboard-card list-card">
	<div class="widget-header">
		<h5>
			Staff Members List
		</h5>

		<!-- <nav class="category-scroll-bar">
			<button class="chip" (click)="urType=''">
				<i class="bi bi-people-fill"></i>
				<span>All at Once</span>
			</button>
			<button class="chip" (click)="urType='T'">
				<i class="bi bi-person-check-fill"></i>
				<span>Trial Users</span>
			</button>
			<button class="chip" (click)="urType='K'">
				<i class="bi bi-person-lines-fill"></i>
				<span>KYC Details</span>
			</button>
			<button class="chip" (click)="urType='P'">
				<i class="bi bi-person-fill-check"></i>
				<span>Paid Users</span>
			</button>
		</nav> -->
		<div>
			<!-- <button class="btn btn-sm btn-light py-0 me-3" (click)="pullme = !pullme">
				<i class="bi bi-list-check"></i>
				Filter!
			</button> -->

			<button class="btn btn-sm btn-light py-0" data-bs-toggle="modal" data-bs-target="#frmBackdrop" 
				(click)="newClick()">
				+Add New
			</button>
		</div>
	</div>

	<!-- <div class="staff-card overlap-child" [class.active]="pullme"
		(click)="pullme=false">
		<div class="staff-card-body">
			<div class="row g-3 align-items-end">
				<div class="col-md-4 col-lg-3">
					<label class="form-label small fw-semibold text-muted">Search</label>
					<div class="input-group">
						<input type="text" class="form-control"
							placeholder="Name, ID, email, designation…"
							[(ngModel)]="searchQuery">
					</div>
				</div>
				<div class="col-6 col-sm-4 col-md-2">
					<label class="form-label small fw-semibold text-muted">Staff Type</label>
					<select class="form-select" [(ngModel)]="filterType">
						<option value="">All Types</option>
						@for (t of staffTypes; track t) { <option [value]="t">{{ t }}</option> }
					</select>
				</div>
				<div class="col-6 col-sm-4 col-md-2">
					<label class="form-label small fw-semibold text-muted">Department</label>
					<select class="form-select" [(ngModel)]="filterDept">
						<option value="">All Depts</option>
						@for (d of departments; track d) { <option [value]="d">{{ d }}</option> }
					</select>
				</div>
				<div class="col-6 col-sm-4 col-md-2">
					<label class="form-label small fw-semibold text-muted">Status</label>
					<select class="form-select" [(ngModel)]="filterStatus">
						<option value="">All Statuses</option>
						@for (s of statusOptions; track s) { <option [value]="s">{{ s }}</option> }
					</select>
				</div>
				<div class="col-6 col-sm-4 col-md-2">
					<label class="form-label small fw-semibold text-muted">Employment</label>
					<select class="form-select" [(ngModel)]="filterEmpType">
						<option value="">All</option>
						@for (e of employmentTypes; track e) { <option [value]="e">{{ e }}</option> }
					</select>
				</div>
			</div>
		</div>
	</div> -->

	<div class="w-100">
		<table id="orgTable" class="table table-striped w-100">
			<thead>
				<tr>
					<th>#</th>
					<th>Name</th>
					<th>Type/Dept.</th>
					<th>Employment</th>
					<th>Contact</th>
					<th>Experience</th>
					<th style="text-align: end;">Action</th>
				</tr>
			</thead>
			<tbody>
				@for(data of allData; track data.for_trial; let idx = $index;) {
				@if((urType=='' || (urType=='T' && data.for_trial && !data.kyc_data) || (urType=='P'
				&& !data.for_trial) || (urType=='K' && data.kyc_data))) {
				<tr style="line-height: normal;">
					<td>{{idx+1}}.</td>
					<td width="300px" class="d-flex;">
						<div class="profile-avatar me-2 mt-1 mb-2" [style.background]="data.profile_photo ? 'transparent' : getAvatarColor(data.id)"
							style="width: 32px; height: 32px; float: left; border-radius: 5px; display: flex; align-items: center; justify-content: center; color: #fff;">
							@if (data.profile_photo) {
								<img [src]="data.profile_photo" alt="{{ data.first_name }}" style="width: 100%; height: 100%; border-radius: 5px;">
							} @else {
								{{ getInitials(data) }}
							}
						</div>						
						<div>
							<b>{{data.first_name}} {{data.last_name}}</b><br>
							<small>({{dataService.getDesiName(data.designation)}})</small>
						</div>
					</td>
					<td>{{data.staff_type}}<br><small>{{dataService.getDeptName(data.department)}}</small></td>
					<td>{{data.employment}}<br><small>Status: {{data.status}}</small></td>
					<td>{{data.mobile}}<br><small>{{data.email}}</small></td>
					<td>{{data.experience}} yrs.<br><small>from {{data.city}}</small></td>
					<td>
						<div class="d-flex gap-2 justify-content-end" *ngIf="data.id">
							<span style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#frmBackdrop"
								(click)="viewClick(data)" title="View Details">
								<i class="bi bi-eye text-primary"></i>
							</span>

							<span style="cursor: pointer;" data-bs-toggle="modal" data-bs-target="#frmBackdrop"
								(click)="editClick(data)" title="Modify">
								<i class="bi bi-pencil-square text-success"></i>
							</span>

							<span style="cursor: pointer;" (click)="deleteClick(data.id)" title="Delete">
								<i class="bi bi-trash3 text-danger"></i>
							</span>
						</div>
					</td>
				</tr>
				}
				}
			</tbody>
		</table>

		<div class="text-danger" align="center" *ngIf="allData && !allData.length && !loading">
			<i class="bi bi-x-circle"></i> No data available.
		</div>
	</div>
</div>

<div class="modal fade" id="frmBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
	aria-labelledby="frmBackdropLabel" aria-hidden="true">
	<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable" [ngClass]="isView ? 'modal-xl' : 'modal-lg'">
		<div class="modal-content">
			<div class="modal-header">
				<h1 class="modal-title fs-5" id="frmBackdropLabel">Staff Details</h1>
				<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
					(click)="isView=false; isEdit=false;"></button>
			</div>
			<div class="modal-body" style="min-height: 400px;">
				@if(!isView) {
					<app-staff-form [action]="btnClick"></app-staff-form>
				} @else {
					<app-staff-view [data]="selStaff"></app-staff-view>
				}
			</div>
			<div class="modal-footer py-2">
				<!-- <button type="button" class="col-2 btn btn-sm btn-secondary" data-bs-dismiss="modal">Cancel</button>
				<button type="button" class="col-2 btn btn-sm btn-primary"
					(click)="btnClick = isEdit ? 'update' : 'save';">
					{{isEdit ? 'Update' : 'Save'}}
				</button> -->
			</div>
		</div>
	</div>
</div>
